module.exports = __webpack_public_path__ + "static/media/HTML.418d6a77.jpg";